<template>
    <label
        v-if="!!label"
        :for="name"
        class="VvLabel"
    >
        {{ label }} <span class="text-xs font-normal text-gray-400" v-if="optional">{{ optionalText }}</span>
    </label>
    <div :class="{ 'mt-1': !!label }">
        <Field
            :name="name"
            :label="label"
            :value="modelValue"
            @input="onInput"
            :validate-on-blur="validateOnBlur"
            :validate-on-change="validateOnChange"
            :validate-on-input="validateOnInput"
            :validate-on-model-update="validateOnModelUpdate"
            v-slot="{ field }"
        >
            <textarea
                v-bind="field"
                :id="name"
                :tabindex="tabIndex"
                rows="3"
                class="VvTextarea--Default"></textarea>
        </Field>
    </div>
    <div class="mt-2">
        <ErrorMessage
            :name="name"
            v-slot="{ message }"
        >
            <p class="VvErrorMessage__Text">{{ message }}</p>
        </ErrorMessage>
    </div>
    <div class="mt-2">
        <p v-if="!!helpText" class="VvHelpText--Default">{{ helpText }}</p>
    </div>
</template>
<script>
import { Field, ErrorMessage } from 'vee-validate';
import { I18nPlugin } from '@/core/plugins';

const i18n = I18nPlugin.getDefaultI18nInstance();

/**
 * Textarea pattern based on VeeValidate.
 *
 * @author Dimitris Gkoulis
 * @createdAt 15 January 2021
 * @lastModifiedAt 19 February 2021
 */
export default {
    name: 'VvTextarea',
    inheritAttrs: false,
    components: {
        Field,
        ErrorMessage
    },
    emits: [
        'update:modelValue',
        'update-batch'
    ],
    props: {
        name: {
            type: String,
            required: true
        },
        label: String,
        optional: Boolean,
        optionalText: {
            type: String,
            default: function () {
                return i18n.global.t('Optional');
            }
        },
        helpText: String,
        modelValue: null,
        tabIndex: Number,
        // FormVueLate + VeeValidate specifics.
        validateOnBlur: {
            type: Boolean,
            default: true
        },
        validateOnChange: {
            type: Boolean,
            default: true
        },
        validateOnInput: {
            type: Boolean,
            default: true
        },
        validateOnModelUpdate: {
            type: Boolean,
            default: true
        },
        validation: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        onInput (event) {
            this.$emit('update:modelValue', event.target.value);
        }
    }
};
</script>

<style>
.VvTextarea--Default {
    @apply shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md;
    @apply text-lg;
    @apply dark:bg-gray-700 dark:border-gray-700 dark:text-gray-100;
    @apply dark:focus:ring-gray-500 dark:focus:border-gray-500;
}
</style>
